// ---------------------------------------------------------------------------
// API endpoint constants
//
// Most endpoints are defined as `ApiService.Endpoint.*` on `api-service.ts`.
// This file exists for newer endpoint families that prefer an object-scoped
// namespace over the flat static enum. Keep both in sync when adding routes.
// ---------------------------------------------------------------------------

export const API = {
	ballotAccess: {
		imports: (campaignId: number, driveId: number) =>
			`/campaigns/${campaignId}/ballot-access/drives/${driveId}/signers/imports`,
		importUpload: (campaignId: number, driveId: number) =>
			`/campaigns/${campaignId}/ballot-access/drives/${driveId}/signers/import`,
		importConfirm: (campaignId: number, driveId: number, batchId: number) =>
			`/campaigns/${campaignId}/ballot-access/drives/${driveId}/signers/import/${batchId}/confirm`,
		importDetail: (campaignId: number, driveId: number, batchId: number) =>
			`/campaigns/${campaignId}/ballot-access/drives/${driveId}/signers/imports/${batchId}`,
		importErrorsCsv: (campaignId: number, driveId: number, batchId: number) =>
			`/campaigns/${campaignId}/ballot-access/drives/${driveId}/signers/imports/${batchId}/errors.csv`,
		checkDuplicate: (campaignId: number) =>
			`/campaigns/${campaignId}/ballot-access/signers/check-duplicate`,
		sheets: (campaignId: number, driveId: number) =>
			`/campaigns/${campaignId}/ballot-access/drives/${driveId}/sheets`,
		sheetDetail: (campaignId: number, driveId: number, sheetId: number) =>
			`/campaigns/${campaignId}/ballot-access/drives/${driveId}/sheets/${sheetId}`,
		sheetCommit: (campaignId: number, driveId: number, sheetId: number) =>
			`/campaigns/${campaignId}/ballot-access/drives/${driveId}/sheets/${sheetId}/commit`,
		sheetDiscard: (campaignId: number, driveId: number, sheetId: number) =>
			`/campaigns/${campaignId}/ballot-access/drives/${driveId}/sheets/${sheetId}/discard`,
	},
	// PRD-43 — campaign volunteers
	volunteers: {
		list: (campaignId: number) => `/campaigns/${campaignId}/volunteers`,
		count: (campaignId: number) => `/campaigns/${campaignId}/volunteers/count`,
		export: (campaignId: number) =>
			`/campaigns/${campaignId}/volunteers/export`,
		import: (campaignId: number) =>
			`/campaigns/${campaignId}/volunteers/import`,
		importJob: (campaignId: number, jobId: number) =>
			`/campaigns/${campaignId}/volunteers/import/${jobId}`,
		detail: (campaignId: number, volunteerId: number) =>
			`/campaigns/${campaignId}/volunteers/${volunteerId}`,
	},
} as const;
